import { GatsbyImage } from 'gatsby-plugin-image'
import { getGatsbyImageData } from 'gatsby-source-sanity'
import { getImageDimensions } from '@sanity/asset-utils'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { sanity } from '../../client-config'
import { figure, captionWrapper } from './figure.module.css'

interface Props {
  value: {
    asset: {
      _ref?: string
      _id: string
    }
    alt?: string
    caption?: string
  }
}

function Figure({ value }: Props) {
  if (!value.asset._ref && !value.asset._id) return null

  const { width, height } = getImageDimensions(value)
  const aspectRatio = width / height

  const imageNode = value.asset._ref || value.asset._id
  const imageData = getGatsbyImageData(imageNode, { aspectRatio }, sanity)

  if (!imageData) return null

  return (
    <figure className={figure}>
      <Zoom>
        <GatsbyImage image={imageData} alt={value.alt || ''} />
      </Zoom>
      {value.caption && (
        <figcaption className={captionWrapper}>{value.caption}</figcaption>
      )}
    </figure>
  )
}

export default Figure
